export default __webpack_public_path__ + "static/media/edit_white.db639983.svg";